import {Component, computed, input, output} from '@angular/core';
import {TimeframePlannedDatesCardComponent} from '../timeframe-planned-dates-card/timeframe-planned-dates-card.component';
import {TimeframeSubPhaseCardComponent} from '../timeframe-sub-phase-card/timeframe-sub-phase-card.component';
import {TimeframeDisplayVM} from './timeframe-display.types';

@Component({
  selector: 'app-timeframe-display',
  imports: [TimeframePlannedDatesCardComponent, TimeframeSubPhaseCardComponent],
  templateUrl: './timeframe-display.component.html',
})
export class TimeframeDisplayComponent {
  readonly projectId = input.required<number>();
  readonly config = input.required<TimeframeDisplayVM>();
  readonly isReadOnly = input.required<boolean>();

  readonly submissionDateUpdated = output<void>();

  private readonly currentPhase = computed(() => this.config().currentPhase);

  protected readonly initialEditable = computed(() => {
    const isReadOnly = this.isReadOnly();
    return !isReadOnly && !this.currentPhase()?.extendedSubPhase;
  });
  protected readonly extendedEditable = computed(() => {
    const isReadOnly = this.isReadOnly();
    return !isReadOnly && !this.currentPhase()?.finalSubPhase;
  });
}
